import React from 'react';
import useApiDownload, { isApiDownloadLink } from '../../hooks/useApiDownload';

export { isApiDownloadLink };

interface IProps {
  href: string;
  children?: React.ReactNode;
}

// A download link the assistant wrote into its answer. The route needs the bearer token, so
// the click fetches the file and saves it instead of navigating.
const DownloadLink = ({ href, children }: IProps) => {
  const download = useApiDownload();

  const onClick = (e: React.MouseEvent) => {
    e.preventDefault();
    download(href);
  };

  return (
    <a href={href} onClick={onClick} className="chat-md-download">
      {children}
    </a>
  );
};

export default DownloadLink;
